module.exports = function(popularposts) {
	"use strict";
  popularposts
  .controller('popularpostsController', popularpostsController)
	popularpostsController.$inject = ["elasticSearch","config","$timeout","$http","$scope","$rootScope","NgTableParams","getDataService", "jQuery","refreshtokenService","reqursiveService","deleteDataService","alertService", "putDataService","postDataService","serverError","keyPress","offlineError"];
  function popularpostsController(elasticSearch,config,$timeout,$http,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,reqursiveService,deleteDataService,alertService,putDataService,postDataService,serverError,keyPress,offlineError) {
    var vmpp = this;
    vmpp.defaultTab = 'naslovna';
    vmpp.hasPosts = false;
    vmpp.noResult = false;
    vmpp.selectedCategoryAction = { value:vmpp.defaultTab};
    vmpp.popularPostsSave = [];
    vmpp.popularposts = [];
    vmpp.hasPopularPosts = true;
    // vmpp.hiddenResult = true;
    // vmpp.hasResult = true;
    // vmpp.searchPage = 0;
    // vmpp.postResult = [];
    vmpp.switchCategoryAction= function(category_id) {
      // vmpp.searchPostsData = null;
      vmpp.popularposts = [];
      vmpp.popularPostsSave = [];
      vmpp.defaultTab = category_id
      getPopularPosts(vmpp.defaultTab);
      if(vmpp.dataGoogle) {
        if(vmpp.dataGoogle[vmpp.defaultTab]) {
          vmpp.noResult = false;
          vmpp.hasPosts = true; 
          vmpp.popularpostsGoogle = vmpp.dataGoogle[vmpp.defaultTab];
        } else {
          vmpp.noResult = true;
          vmpp.hasPosts = false; 
        }
      } 
    }
    vmpp.addPostFromSearch = function(obj) {
      var exist = false;
      for(var i=0; i<vmpp.popularposts.length; i++) {  
        if(obj.id==vmpp.popularposts[i].id) {
          exist = true;
        }
      }
      if(!exist) {
        vmpp.popularposts.push({'id':obj.id,'title':obj.title,'uri':obj.uri});
        vmpp.hasPopularPosts = true;
      }
    }
    // vmpp.chooseSearchData = function(post) {
    //   vmpp.searchPostsData = '('+post._id+') - ' +  post._source.post_title;
    //   vmpp.searchPostsTitle = post._source.post_title; 
    //   vmpp.hiddenResult = true;
    //   vmpp.searchPostId = post._id;
    //   vmpp.searchPostUri = post._source.url.substr(23);
    //   vmpp.searchObj = {
    //     'id': vmpp.searchPostId,
    //     'title' : vmpp.searchPostsTitle,
    //     'uri' : vmpp.searchPostUri
    //   };
    // };
    // angular.element(document).on('mousedown', function(e) {
    //   if(angular.element(document.getElementsByClassName("autocomplete-result"))) {
    //   var container = angular.element(document.getElementsByClassName("autocomplete-result"));
    //   var serch_input = angular.element(document.getElementsByClassName("search-autocomplete"));
    //   if (!container.is(e.target) // if the target of the click isn't the container...
    //     && container.has(e.target).length === 0 && !vmpp.hiddenResult && !serch_input.is(e.target) && serch_input.has(e.target).length===0) // ... nor a descendant of the container
    //   {
    //     $scope.$apply(function () {
    //       vmpp.hiddenResult = true;
    //       vmpp.postResult = [];
    //       vmpp.searchPage = 0;
    //     });
    //   }}
    // });
    // vmpp.searchPress = function(evt,star) {
    //   keyPress(evt,star);
    // }
    // vmpp.readMore = function() {
    //   vmpp.searchPage +=10;
    //   $timeout(function() {
    //     vmpp.search('loadMore');
    //   },0)
    // }
    // vmpp.search = function(loadMore) { 
    //   var size=10;
    //   vmpp.loadMore = false;
    //   if(loadMore!='loadMore') {
    //     vmpp.searchPage = 0;
    //     vmpp.postResult = [];
    //   }
    //   // vmpp.hiddenResult = true;
    //   if(vmpp.searchPostsData) { 
    //     if(vmpp.searchPostsData.length >1) {
    //       var url = elasticSearch.getUrl(vmpp.searchPostsData);
    //       url = url + '&from='+ vmpp.searchPage +'&size='+ size;
          
    //       $http({
    //         method: 'GET',
    //         url: url
    //       }).then(function successCallback(response) {
    //           if(loadMore=='loadMore') {
    //             vmpp.postResult = vmpp.postResult.concat(response.data.hits.hits);
    //           } else {
    //             vmpp.postResult = response.data.hits.hits;
    //           }
    //           if(vmpp.postResult.length > 0) {
    //             vmpp.hasResult = true;
    //             vmpp.loadMore = true;
    //           } else {
    //             vmpp.hasResult = false;
    //           }
    //           vmpp.hiddenResult = false;
    //           if(response.data.hits.total >vmpp.postResult.length) {
    //             vmpp.loadMore = true;
    //           } else {
    //             vmpp.loadMore = false;
    //           }
    //           // this callback will be called asynchronously
    //           // when the response is available
    //       }, function errorCallback(response) {
    //         if(!window.navigator.onLine) {
    //           offlineError()
    //           return
    //         }
    //           // called asynchronously if an error occurs
    //           // or server returns response with an error status.
    //       });
    //     } else {
    //       vmpp.hiddenResult = true;
    //     } 
    //   } else {
    //     vmpp.hiddenResult = true;
    //   }
    // }
    vmpp.popularPostSave = function(categoryName) {
      vmpp.popularPostsSave =[];
      if(vmpp.popularposts.length > 0) {
        $rootScope.hasLoaded = false;
        vmpp.popularposts = vmpp.popularposts.slice(0,10);

        for (var i=0; i<vmpp.popularposts.length;i++) {
          vmpp.popularPostsSave.push({'id':vmpp.popularposts[i].id, 'title':vmpp.popularposts[i].title, "uri":vmpp.popularposts[i].uri});
        }
        jQuery("html, body").animate({
          scrollTop: 0
        }, 400);
        var postFunction = function() {
          postDataService.save({
            param1:'widgets',
            param2:'popular' 
          },{
            "category": vmpp.defaultTab,
            "posts"  : vmpp.popularPostsSave, 
          }).$promise.then(function(postPopular){
            $rootScope.hasLoaded = true;
            // vmpp.popularposts = postPopular.posts;
            alertService('success','Success ', postPopular.message, 2000);
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError()
              $rootScope.hasLoaded = true;
              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
              return
            }
            if(error.status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {   
                    postFunction();
                  }
                },
                function(error) {
                  // report something
                },
                function(progress) {
                 // report progress
              });
            } else if(error.status ==502) {
              serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
            }
            $rootScope.hasLoaded = true; 
          });
        }
        postFunction();
      }
    }
    vmpp.addGoolePostsToPopularPosts = function() {
      vmpp.hasPopularPosts = true;
      Array.prototype.unique = function() {
        var a = this.concat();
        for(var i=0; i<a.length; ++i) {
            for(var j=i+1; j<a.length; ++j) {
                if(a[i].id === a[j].id)
                    a.splice(j--, 1);
            }
        }
        return a;
      };
      vmpp.popularposts = vmpp.popularposts.concat(vmpp.popularpostsGoogle).unique();
    }
    vmpp.removeFromPopularPosts = function(index) {
      vmpp.popularposts.splice(index,1);
      if(vmpp.popularposts.length == 0) {
        vmpp.hasPopularPosts = false;
      }
    }
    
    vmpp.addPost =function(postObj) {
      vmpp.hasPopularPosts = true;
      vmpp.addPostFromSearch(postObj);
    }
    
    var getPopularPosts = function(categoryName) {
      // vmpp.popularposts = [];
      $rootScope.hasLoaded = false;
      getDataService.get({param1:'widgets', param2: 'popular', param3:categoryName}).$promise.then(function(data){
        
        $timeout(function(){
        $rootScope.hasLoaded = true;
        vmpp.popularposts = data.posts;
        },300);
          
        vmpp.hasPopularPosts = true;
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {
                getPopularPosts(vmpp.defaultTab);
              }
            },
            function(error) {
            },
            function(progress) {
             // report progress
          });
        } else if(error.status ==404) {
           vmpp.hasPopularPosts = false;
        } else if(error.status ==502) {
          serverError()
        } else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        } 
        $rootScope.hasLoaded = true;
        vmpp.popularposts = [];
      });
    }
    var getCategoriesFunction= function() {
      getDataService.get({param1:'categories', param2: null, tree:1}).$promise.then(function(data){
        vmpp.data = data.categories; 
        vmpp.categoriesTabs = [];
        for(var i=0; i< vmpp.data.length; i++) {
          if(vmpp.data[i]._id != 'uncategorized') {
            vmpp.categoriesTabs.push(vmpp.data[i]);
          }
        }
        getPopularPosts(vmpp.defaultTab); 
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {
                getCategoriesFunction();
              }
            },
            function(error) {
            },
            function(progress) {
             // report progress
          });
        } else if(error.status ==502) {
          serverError()
        }else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }   
      });
    }
    getCategoriesFunction();
    vmpp.addGoogleAnalytics = function() {
      vmpp.popularpostsGoogle = [];
      vmpp.hasPosts = false;
      $rootScope.hasLoaded = false;
      var getPopularPostsAnalytics = function() {
        getDataService.get({param1:'analytics', param2: 'popular'}).$promise.then(function(data){
          vmpp.dataGoogle = data;
          
          if(vmpp.dataGoogle[vmpp.defaultTab]) {
            vmpp.popularpostsGoogle = vmpp.dataGoogle[vmpp.defaultTab];
            vmpp.hasPosts = true;
            vmpp.noResult = false; 
          } else {
            vmpp.hasPosts = false;
            vmpp.noResult = true;
          }
           $rootScope.hasLoaded = true;
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {
                  getPopularPostsAnalytics();
                }
              },
              function(error) {
              },
              function(progress) {
               // report progress
            });
          }else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          } 
          $rootScope.hasLoaded = true;   
        });  
      }
      getPopularPostsAnalytics();      
    }
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/popularpostsModule/popularposts/js/popularpostsController.js
// module id = 547
// module chunks = 0